var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c(
            "div",
            { staticClass: "single container-max page-content" },
            [
              _c("div", { staticClass: "row position-relative" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 mt-3 mt-md-5 d-flex justify-content-between align-items-md-center"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center flex-wrap flex-xl-nowrap mb-2"
                      },
                      [
                        _c(
                          "h1",
                          {
                            staticClass: "h2 title d-inline-block",
                            attrs: { "data-testing": "item-name" }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("itemName")(_vm.currentVariation)
                                  ) +
                                  "\n              "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.currentVariation.item.condition.id == 1
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "condition special-tags d-inline-block ml-xl-2"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "badge badge-bundle bg-info" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$translate(
                                            "babyVueTheme::Catview.Condition"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _vm.hasGroupId143 ||
                    _vm.currentVariation.filter.hasManufacturer
                      ? _c(
                          "div",
                          { staticClass: "manufacturer ml-3" },
                          [
                            _vm.hasGroupId143 &&
                            _vm.propertyGroupList.some(function(property) {
                              return (
                                property.id == 407 &&
                                property.values.value == "Kibella"
                              )
                            })
                              ? [_vm._m(0)]
                              : _vm.hasGroupId143 &&
                                _vm.propertyGroupList.some(function(property) {
                                  return (
                                    property.id == 407 &&
                                    property.values.value == "Babyshoppen"
                                  )
                                })
                              ? [_vm._m(1)]
                              : _vm.currentVariation.filter.hasManufacturer
                              ? [
                                  _vm.currentVariation.item.manufacturer.url !=
                                  ""
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              _vm.currentVariation.item
                                                .manufacturer.url
                                          }
                                        },
                                        [
                                          _vm.currentVariation.item.manufacturer
                                            .logo != ""
                                            ? _c("img", {
                                                staticClass: "img-fluid",
                                                attrs: {
                                                  alt:
                                                    _vm.currentVariation.item
                                                      .manufacturer
                                                      .externalName,
                                                  src:
                                                    _vm.currentVariation.item
                                                      .manufacturer.logo
                                                }
                                              })
                                            : _c("p", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.currentVariation.item
                                                      .manufacturer.externalName
                                                  )
                                                }
                                              })
                                        ]
                                      )
                                    : _c("div", [
                                        _vm.currentVariation.item.manufacturer
                                          .logo != ""
                                          ? _c("img", {
                                              staticClass: "img-fluid",
                                              attrs: {
                                                alt:
                                                  _vm.currentVariation.item
                                                    .manufacturer.externalName,
                                                src:
                                                  _vm.currentVariation.item
                                                    .manufacturer.logo
                                              }
                                            })
                                          : _c("p", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.currentVariation.item
                                                    .manufacturer.externalName
                                                )
                                              }
                                            })
                                      ])
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 mb-3" },
                  [_vm._t("image-carousel")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-12 col-md-6 col-lg-6 offset-xl-1 col-xl-5"
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "div",
                          { staticClass: "d-none" },
                          [_vm._t("tag-list")],
                          2
                        ),
                        _vm._v(" "),
                        _vm.hasGroupId143
                          ? [
                              _c(
                                "ul",
                                {
                                  staticClass:
                                    "add-data my-4 list-unstyled py-5 px-4 p-lg-5"
                                },
                                [
                                  _vm._l(_vm.propertyGroupList, function(
                                    property
                                  ) {
                                    return property.id != 311 &&
                                      property.id != 312
                                      ? [
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "mb-3 d-flex align-items-center"
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-check mr-3",
                                                attrs: { "aria-hidden": "true" }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "name font-weight-bold mr-1"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      property.names.name
                                                    ) + ": "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              property.values.value != null
                                                ? _c(
                                                    "span",
                                                    { staticClass: "value" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          property.values.value
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : [
                                                    _c(
                                                      "div",
                                                      { staticClass: "value" },
                                                      _vm._l(
                                                        property.values,
                                                        function(
                                                          multiprop,
                                                          index
                                                        ) {
                                                          return multiprop !=
                                                            null
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "multi d-block"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      multiprop.value
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ]
                                            ],
                                            2
                                          )
                                        ]
                                      : _vm._e()
                                  })
                                ],
                                2
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.attributes.length || Object.keys(_vm.units).length
                          ? _c(
                              "div",
                              { staticClass: "mb-3" },
                              [_c("variation-select")],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentVariation.variation.bundleType === "bundle"
                          ? _c("item-bundle", {
                              attrs: {
                                "bundle-components":
                                  _vm.currentVariation.bundleComponents,
                                "bundle-type":
                                  _vm.currentVariation.variation.bundleType
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("before-price"),
                        _vm._v(" "),
                        _vm.currentVariation.filter.isSalable &&
                        _vm.variationGroupedProperties.length
                          ? _c("div", [_c("order-property-list")], 1)
                          : _vm._e(),
                        _vm._v(" "),
                        _c("graduated-prices"),
                        _vm._v(" "),
                        _c("item-price", {
                          attrs: {
                            "show-cross-price": _vm.isRecommendedPriceActive
                          }
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.currentVariation.tags, function(tag) {
                          return tag.id == 15
                            ? [
                                _c("p", { staticClass: "font-weight-bold" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "babyVueTheme::Single.Spedition"
                                      )
                                    )
                                  )
                                ])
                              ]
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "vat small text-muted mb-3 d-block" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.singleItemFootnote1"
                                  )
                                ) +
                                " "
                            ),
                            _vm.showNetPrices
                              ? [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemExclVAT"
                                      )
                                    )
                                  )
                                ]
                              : [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemInclVAT"
                                      )
                                    )
                                  )
                                ],
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.singleItemExclusive"
                                  )
                                ) +
                                "\n              "
                            ),
                            _vm.hasShippingCostsCategoryId
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      "data-toggle": "modal",
                                      href: "#shippingscosts"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemShippingCosts"
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _c(
                                  "a",
                                  {
                                    attrs: {
                                      title: _vm.$translate(
                                        "Ceres::Template.singleItemShippingCosts"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemShippingCosts"
                                        )
                                      )
                                    )
                                  ]
                                )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm._t("after-price"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center"
                          },
                          [
                            _c("item-availability"),
                            _vm._v(" "),
                            _vm.isWishListEnabled
                              ? _c(
                                  "div",
                                  { staticClass: "fs-wishlist" },
                                  [
                                    _c("add-to-wish-list", {
                                      attrs: {
                                        "variation-id":
                                          _vm.currentVariation.variation.id
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "my-3 my-lg-4" }, [
                          _c(
                            "div",
                            { staticClass: "w-100" },
                            [_vm._t("before-add-to-basket")],
                            2
                          ),
                          _vm._v(" "),
                          _vm.currentVariation.item.itemType === "set"
                            ? _c(
                                "div",
                                { staticClass: "alert alert-info w-100" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemSetInfo"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                { staticClass: "col-12 my-3 px-lg-0" },
                                [
                                  _c("add-to-basket", {
                                    attrs: {
                                      "has-children":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter
                                          .hasActiveChildren,
                                      "has-price": _vm._f(
                                        "hasItemDefaultPrice"
                                      )(_vm.currentVariation),
                                      "interval-quantity":
                                        _vm.currentVariation.variation
                                          .intervalOrderQuantity || 1,
                                      "is-salable":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter.isSalable,
                                      "is-variation-selected":
                                        _vm.isVariationSelected &&
                                        _vm.currentVariation.filter.isSalable,
                                      "item-url": _vm._f("itemURL")(
                                        _vm.currentVariation
                                      ),
                                      "maximum-quantity":
                                        !!_vm.currentVariation.variation
                                          .maximumOrderQuantity &&
                                        _vm.currentVariation.variation
                                          .maximumOrderQuantity > 0
                                          ? _vm.currentVariation.variation
                                              .maximumOrderQuantity
                                          : null,
                                      "minimum-quantity":
                                        _vm.currentVariation.variation
                                          .minimumOrderQuantity,
                                      "order-properties": _vm.currentVariation.properties.filter(
                                        function(prop) {
                                          return prop.property.isOderProperty
                                        }
                                      ),
                                      "has-order-properties":
                                        _vm.currentVariation.hasOrderProperties,
                                      "has-required-order-property":
                                        _vm.currentVariation
                                          .hasRequiredOrderProperty,
                                      "use-large-scale": false,
                                      "show-quantity": true,
                                      "variation-id":
                                        _vm.currentVariation.variation.id
                                    }
                                  })
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "w-100 addition-btn" },
                            [_vm._t("after-add-to-basket")],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _vm._t("additional-content-after-add-to-basket"),
                        _vm._v(" "),
                        _vm.currentVariation.texts.technicalData != ""
                          ? _c("div", [
                              _c("div", {
                                staticClass: "alert alert-warning my-4",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.currentVariation.texts.technicalData
                                  )
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt-3 float-right" }, [
                          _c(
                            "span",
                            { staticClass: "articlenumber text-muted" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "babyVueTheme::Single.itemID"
                                    )
                                  ) +
                                    _vm._s(
                                      _vm.currentVariation.variation.number
                                    )
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm._t("additional-content-after-vat")
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-6 mb-3 mb-md-0" }, [
                  _c("div", { staticClass: "p-4 p-lg-5 singledescription" }, [
                    _c("p", { staticClass: "h4 font-weight-bold mb-4" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "babyVueTheme::Single.productInformation"
                          )
                        ) +
                          ' "' +
                          _vm._s(_vm._f("itemName")(_vm.currentVariation)) +
                          '"'
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.currentVariation.texts.description
                        )
                      }
                    }),
                    _vm._v(" "),
                    _vm.currentVariation.filter.hasManufacturer
                      ? _c(
                          "div",
                          { staticClass: "manufacturer" },
                          [
                            _c(
                              "p",
                              { staticClass: "h5 font-weight-bold mt-4" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "babyVueTheme::Single.manufacturerHeadline"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.currentVariation.item.manufacturer
                              .responsibleName != ""
                              ? _c("p", { staticClass: "mb-1 d-flex" }, [
                                  _c(
                                    "span",
                                    { staticClass: "manu-text mr-2" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "babyVueTheme::Single.manufacturerName"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .responsibleName
                                      )
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentVariation.item.manufacturer
                              .responsibleStreet != ""
                              ? _c("p", { staticClass: "mb-1 d-flex" }, [
                                  _c(
                                    "span",
                                    { staticClass: "manu-text mr-2" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "babyVueTheme::Single.manufacturerStreet"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.currentVariation.item.manufacturer
                                    .responsibleStreet != ""
                                    ? _c("span", { staticClass: "mr-1" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.responsibleStreet
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentVariation.item.manufacturer
                                    .responsibleHouseNo != ""
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.responsibleHouseNo
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentVariation.item.manufacturer
                              .responsiblePostCode != ""
                              ? _c("p", { staticClass: "mb-1 d-flex" }, [
                                  _c(
                                    "span",
                                    { staticClass: "manu-text mr-2" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "babyVueTheme::Single.manufacturerPlz"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.currentVariation.item.manufacturer
                                    .responsiblePostCode != ""
                                    ? _c("span", { staticClass: "mr-1" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.responsiblePostCode
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentVariation.item.manufacturer
                                    .responsibleTown != ""
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.responsibleTown
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(
                              _vm.currentVariation.item.manufacturer
                                .responsibleCountryObject.names,
                              function(country) {
                                return country.language === "de"
                                  ? _c("p", { staticClass: "mb-1 d-flex" }, [
                                      _c(
                                        "span",
                                        { staticClass: "manu-text mr-2" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "babyVueTheme::Single.manufacturerCountry"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(country.name))])
                                    ])
                                  : _vm._e()
                              }
                            ),
                            _vm._v(" "),
                            _vm.currentVariation.item.manufacturer
                              .responsibleEmail != ""
                              ? _c("p", { staticClass: "mb-1 d-flex" }, [
                                  _c(
                                    "span",
                                    { staticClass: "manu-text mr-2" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "babyVueTheme::Single.manufacturerEmail"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          "mailto:" +
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleEmail
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleEmail
                                        )
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentVariation.item.manufacturer
                              .responsiblePhoneNo != ""
                              ? _c("p", { staticClass: "mb-1 d-flex" }, [
                                  _c(
                                    "span",
                                    { staticClass: "manu-text mr-2" },
                                    [_vm._v("Telefon:")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .responsiblePhoneNo
                                      )
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentVariation.item.manufacturer
                              .responsibleContactUrl != ""
                              ? _c("p", { staticClass: "mb-1 d-flex" }, [
                                  _c(
                                    "span",
                                    { staticClass: "manu-text mr-2" },
                                    [_vm._v("Kontakt:")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleContactUrl,
                                        rel: "noopener",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleContactUrl
                                        )
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-md-6 col-lg-6 offset-xl-1 col-xl-5 bigimg mb-3 mb-md-0"
                  },
                  [
                    _vm.hasProperty311 || _vm.hasDefaultImg1
                      ? _c("lazy-img", {
                          attrs: {
                            alt: _vm.currentVariation.texts.name1,
                            "image-url": _vm.getPropertyImg(311, 1),
                            "picture-class": "img-fluid mt-5"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.hasProperty312 || _vm.hasDefaultImg2) &&
                    _vm.currentVariation.images.all.length > 1
                      ? _c("lazy-img", {
                          attrs: {
                            alt: _vm.currentVariation.texts.name1,
                            "image-url": _vm.getPropertyImg(312, 2),
                            "picture-class": "img-fluid mt-5"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "fs-container-list" },
                [_vm._t("item-list-container")],
                2
              ),
              _vm._v(" "),
              _vm._t("feedback-container")
            ],
            2
          )
        ],
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "https://www.babyshoppen.de/kibella" } }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: {
          src:
            "https://cdn02.plentymarkets.com/xk05oz0zb09e/frontend/Herstellerlogos/kibella_logo_150x75.png",
          alt: "Kibella"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { attrs: { href: "https://www.babyshoppen.de/babyshoppen" } },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src:
              "https://cdn02.plentymarkets.com/xk05oz0zb09e/frontend/Herstellerlogos/babyshoppen_logo_150x75.png",
            alt: "Babyshoppen"
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }